import React from 'react';
import { Fade, FormHelperText } from '@mui/material';

function withErrorHelperText(WrappedComponent, { error, touched, warning }) {
  // eslint-disable-next-line react/prop-types
  return ({ removeErrorSpacing, ...props }) => {
    return (
      <div data-testid="withErrorHelperText-id" style={{ width: '100%' }}>
        <WrappedComponent error={Boolean(error)} {...props} />
        {(!removeErrorSpacing || (Boolean(error) && Boolean(touched))) && (
          <Fade in={(Boolean(error) && Boolean(touched)) || Boolean(warning)}>
            <FormHelperText
              sx={{
                color: warning ? 'warning.main' : 'error.main',
                paddingBottom:
                  (Boolean(error) && Boolean(touched)) || Boolean(warning) ? '24px' : 'none',
              }}
            >
              {error || warning || ' '}
            </FormHelperText>
          </Fade>
        )}
      </div>
    );
  };
}

export default withErrorHelperText;
